<template>
  <div>
    <v-navigation-drawer app left :mini-variant.sync="mini" light v-model="drawer" overflow clipped>
      <!-- <v-avatar
        :tile="false"
        size="128px"
        class="strategio-avatar grey lighten-4"
      >
        <img v-if="isProfileImage(userInfo.profileImageUrl)" :src="userInfo.profileImageUrl">
        <div v-if="!isProfileImage(userInfo.profileImageUrl)" class="strategio-acron grey-text text-darken-1">{{acron}}</div>
      </v-avatar> -->
      <!-- <div class="strategio-nombre">{{userInfo.name}}</div> -->
      <!-- <div class="strategio-cargo grey-text text-darken-1">{{userInfo.description}}</div> -->
      <v-list style="border-top: 1px lightgray solid">
        <v-list-tile @click="goReports()" >
          <v-list-tile-action>
            <v-btn icon dark large :flat="!(currentLocation == 'MainPage')" style="background-color:#19BAE8">
              <v-icon :color="currentLocation === 'MainPage' ? 'white' : 'grey darken-1'">
                dashboard
              </v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :style="{'color': currentLocation === 'MainPage' ? '#19BAE8' : ''}">
              Reportes
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="goMyAccount()">
          <v-list-tile-action>
            <v-btn icon dark large :flat="!(currentLocation === 'UserAccount')" style="background-color:#19BAE8">
              <v-icon :color="currentLocation === 'UserAccount' ? 'white' : 'grey darken-1'">
                account_circle
              </v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :style="{'color': currentLocation === 'UserAccount' ? '#19BAE8' : ''}">
              Mi cuenta
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="goSupervise()" v-if="showSupervise">
          <v-list-tile-action>
            <v-btn icon dark large :flat="!(currentLocation === 'SuperviseDashboard')" style="background-color:#19BAE8">
              <v-icon :color="currentLocation === 'SuperviseDashboard' ? 'white' : 'grey darken-1'">
                assignment_turned_in
              </v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :style="{'color': currentLocation === 'SuperviseDashboard' ? '#19BAE8' : ''}">
              Supervisar
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="goAdmin()" v-if="showAdmin">
          <v-list-tile-action>
            <v-btn icon dark large :flat="!(currentLocation === 'UserAdmin')" style="background-color:#19BAE8">
              <v-icon :color="currentLocation === 'UserAdmin' ? 'white' : 'grey darken-1'">
                tune
              </v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :style="{'color': currentLocation === 'UserAdmin' || currentLocation === 'UserAdminByID' || currentLocation === 'UserAdminCreate' ? '#19BAE8' : ''}">
              Administrar
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider inset></v-divider>
        
        <v-list-tile @click="logOut()">
          <v-list-tile-action>
            <v-icon color="red">power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Cerrar sesion</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider inset></v-divider>

        <v-list-tile @click="mini = !mini">
          <v-list-tile-action>
            <v-icon color="grey darken-1">
              {{ mini ? 'arrow_forward' : 'arrow_back'}}
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!-- <v-card color="grey lighten-4" flat > -->
    <v-toolbar clipped-left app color="white" light>
      <div style="width:80px;height:100%;cursor:pointer;border-right:1px lightgray none" class="ml-0 px-2"
        @click="drawer = !drawer"
      >
        <v-layout fill-height align-center class="" justify-center>
          <img
            class="ma-2"
            style="max-width:100%;max-height:85%;"
            :src="require('@/assets/logotipo-strategio.png')"
            alt="strategio-logo"
          >
        </v-layout>

      </div>
      <!-- <v-btn v-if="showMenu" icon>
        <v-icon>menu</v-icon>
      </v-btn> -->
      <v-toolbar-title style="height:100%;border:1px red none;">
        <div style="height:100%" class="layout align-center">
          <img
            height="40px"
            src="logo-company.png"
            alt="logo-company"
          >
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-text-field
        id="filter-textfield"
        v-if="currentLocation === 'MainPage' && !['xs'].includes($vuetify.breakpoint.name)"
        solo
        v-model.lazy="searchProps.searchCriteria"
        @keyup.enter="searchItems()"
        label="Búsqueda"
        style="border-radius:40px"
        class="hidden-xs-only mr-3"
      ></v-text-field>
      <v-btn :disabled="false" flat icon @click="toggleSearchBar" class="hidden-sm-and-up">
        <v-icon>search</v-icon>
      </v-btn>
      <div class="mr-2 hidden-xs-only" style="font-size:13px; font-weight:500">
        <span style="color:#01C0D1">Hola, </span><span>{{userInfo.name}}</span>
      </div>
      <v-avatar
        :tile="false"
        size="45px"
        class="grey lighten-4"
      >
        <img v-if="isProfileImage(userInfo.profileImageUrl)" :src="userInfo.profileImageUrl">
        <div v-if="!isProfileImage(userInfo.profileImageUrl)" class="strategio-acron grey--text text--darken-1">{{acron}}</div>
      </v-avatar>
      <v-btn color="grey darken-1" :disabled="tutorialDisabled" flat icon @click="startTutorial()">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn color="grey darken-1" id="favorite-button" flat icon @click="goFavorites()">
        <v-icon>star</v-icon>
      </v-btn>
    </v-toolbar>
      <!-- <v-toolbar clipped-left app color="white" light flat> -->
        <!-- <v-btn v-if="showMenu" icon @click="mini = !mini">
          <v-icon>menu</v-icon>
        </v-btn> -->
        <!-- <v-toolbar-title>
          Strategio
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn :disabled="tutorialDisabled" flat icon @click="startTutorial()">
          <v-icon>help_outline</v-icon>
        </v-btn>
        <v-btn id="favorite-button" flat icon @click="goFavorites()">
          <v-icon>star</v-icon>
        </v-btn> -->
      <!-- </v-toolbar> -->
    <!-- </v-card> -->
  </div>
</template>

<script>
import eventBus from '../../utils/eventBus'
import introBus from '../../utils/introBus'
import userStorage from '../../storage/userStorage'

export default {
  name: 'strategio-app-bar',
  data () {
    const userInfo = userStorage.getUserInfo()
    if (Object.keys(userInfo).length === 0) {
      this.$router.push('login')
    }
    let showDrawer = !['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name)
    return {
      userInfo,
      showMenu: userInfo.userType !== 'DEMO',
      showSupervise: ['ADMIN', 'SUPERVISOR'].indexOf(userInfo.userType) > -1,
      showAdmin: userInfo.userType === 'ADMIN',
      drawer: showDrawer,
      acron: this.getAcron(userInfo.name),
      currentLocation: this.$route.name,
      tutorialDisabled: true,
      mini: true
    }
  },
  mounted () {
    eventBus.$off('enable-tutorial-button')
    eventBus.$on('enable-tutorial-button', () => {
      this.tutorialDisabled = false
    })
  },
  methods: {
    startTutorial () {
      introBus.setIntroBus(introBus.getVueInstance().$intro())
      let intro = introBus.getIntroBus()
      // intro.onskip(() => {}) // Fixed intro.js bug

      intro.setOptions({
        disableInteraction: true,
        scrollToElement: true,
        skipLabel: 'Salir',
        nextLabel: 'Siguiente',
        prevLabel: 'Previo',
        doneLabel: 'Listo',
        tooltipClass: 'strategio-introjs-customclass',
        steps: [
          {
            element: '#favorite-button',
            intro: 'Este botón le llevará a la sección de reportes marcados como favoritos. Desde allí también se podrá desmarcar cualquier reporte'
          }
        ]
      })

      switch (this.currentLocation) {
        case 'Login':
          break
        case 'MainPage':
          // emits to: /routes/main-page.vue
          eventBus.$emit('start-main-page-tutorial')
          break
        case 'SearchItems':
          break
        case 'ShowReport':
          break
        case 'Favorites':
          break
        case 'UserAccount':
        case 'UserAdminByID':
        case 'UserAdminCreate':
          // emits to: /components/users/user-form.vue
          eventBus.$emit('start-user-form-tutorial')
          break
        case 'UserAdmin':
          // emits to: /routes/user-admin.vue
          eventBus.$emit('start-user-admin-tutorial')
          break
        case 'SuperviseDashboard':
          // emits to: /routes/supervise-dashboard.vue
          eventBus.$emit('start-supervise-dashboard-tutorial')
          break
        default:
          break
      }
    },
    toggleSearchBar () {
      // emites to: routes/main-page.vue
      eventBus.$emit('toggle-search-bar')
    },
    isProfileImage (url) {
      if (url) {
        return url.trim() !== ''
      }
      return false
    },
    getAcron (text) {
      let acron = ''
      if (text.length > 1) {
        const matches = text.match(/\b(\w)/g)
        acron = (matches.length > 1) ? (matches[0] + matches[1]) : (text[0] + text[1])
      }
      return acron.toUpperCase()
    },
    goFavorites () {
      this.$router.push('/user/favorites')
    },
    goReports () {
      this.$router.push('/0')
    },
    goMyAccount () {
      this.$router.push('/user/account')
    },
    goAdmin () {
      this.$router.push('/user/admin')
    },
    goSupervise () {
      this.$router.push('/supervise/dashboard')
    },
    logOut () {
      this.$router.push('/login')
    }
  },
  props: {
    searchCriteria: {
      type: String,
      default () {
        return 'halp'
      }
    },
    searchProps: {
      type: Object,
      default () {
        return { searchCriteria: '' }
      }
    },
    searchItems: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>
<style>
.strategio-cargo {
  text-align: center;
}
.strategio-nombre {
  font-size: 24px;
  font-weight: 300;
  text-align: center;
}
.strategio-avatar {
  text-align: center;
  margin-left: 84px;
  margin-top: 40px;
  margin-bottom: 32px;
}
.strategio-acron {
  font-weight: 300;
  font-size: 20px;
}
.introjs-helperLayer {
  opacity: 0.7;
  background-color: gray !important;
}

.strategio-introjs-customclass {
  /* font-size: 20px; */
  font-family: 'Roboto', 'Material Icons', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/header-bar/strategio-app-bar.vue